import { RootState } from 'store/rootReducer';

export const selectedUserSelector = (state: RootState) => state.Message.selectedUser;

export const agentIdSelector = (state: RootState) => state.Message.agentId;

export const flowAttrSelector = (state: RootState) => state.PathBuilder.flowAttributes;
